const breakpoints = {
  xsmall: '20em',
  small: '40em',
  medium: '73em',
  large: '96em',
  xlarge: '120em',
}

export default {
  xsmall: `(min-width: ${breakpoints.xsmall})`,
  small: `(min-width: ${breakpoints.small})`,
  medium: `(min-width: ${breakpoints.medium})`,
  large: `(min-width: ${breakpoints.large})`,
  xlarge: `(min-width: ${breakpoints.xlarge})`,
}
